// Local fallback data — mirrors backend BUSINESS_CONFIG so the site renders
// beautifully even before the API responds. Backend is the source of truth.

export const FALLBACK_CONFIG = {
  business_name: "She Cuts Barber Studio",
  owner_name: "Yolanda Campbell",
  tagline: "Precision Meets Peace.",
  sub_tagline: "Premium Grooming. Personal Service. Atlanta Style.",
  established: "2021",
  phone: "678-851-2947",
  phone_tel: "+16788512947",
  email: "shecutsme@yahoo.com",
  address_line_1: "759 W Peachtree St NW #101",
  address_line_2: "Atlanta, GA 30308",
  neighborhood: "Midtown Atlanta",
  google_rating: 5.0,
  google_review_count: 181,
  google_reviews_url: "https://www.google.com/maps/place/She+Cuts+Barber+Studio/",
  yelp_url: "https://m.yelp.com/biz/shecuts-barber-studio-atlanta",
  reviews_platform: "Yelp",
  reviews_platform_url: "https://m.yelp.com/biz/shecuts-barber-studio-atlanta",
  google_maps_url:
    "https://www.google.com/maps/dir/?api=1&destination=759+W+Peachtree+St+NW+%23101+Atlanta+GA+30308",
  calendly_url: "https://calendly.com/shecutsbarberstudio/appointment",
  instagram_url: "https://www.instagram.com/shecutsbarberstudio",
  facebook_url: "https://www.facebook.com/share/186a9sD9GC/",
  voyageatl_url:
    "https://voyageatl.com/interview/exploring-life-business-with-yolanda-campbell-of-shecuts-barber-studio/",
  yoili_url: "https://yoilidesigns.com",
  logo_url:
    "https://customer-assets-v7afamib.emergentagent.net/job_c52c6630-c88c-4049-aa86-0ea48b1cb3cc/artifacts/41aa9nk4_IMG_2203.jpeg",
  founder_portrait:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_yolanda-cuts/artifacts/xqiofdle_IMG_7593.jpeg",
  hours: [
    { day: "Monday", open: "12:00 PM", close: "7:00 PM", closed: false },
    { day: "Tuesday", open: "12:00 PM", close: "7:00 PM", closed: false },
    { day: "Wednesday", open: "12:00 PM", close: "7:00 PM", closed: false },
    { day: "Thursday", open: "12:00 PM", close: "7:00 PM", closed: false },
    { day: "Friday", open: "12:00 PM", close: "7:00 PM", closed: false },
    { day: "Saturday", open: "8:00 AM", close: "2:00 PM", closed: false },
    { day: "Sunday", open: null, close: null, closed: true },
  ],
};

// Single locked hero video — the authentic studio-atmosphere clip supplied by
// the owner. Transcoded to a compact 720p H.264 mp4 (~1.7MB) and self-hosted
// for instant paint on cellular. The hero never rotates.
export const HERO_VIDEO = "/videos/hero-studio.mp4";

// Authentic She Cuts photograph used as hero poster + supporting sections
export const HERO_POSTER = "/videos/hero-studio-poster.jpg";
export const FOUNDER_ACCENT = "/gallery/shecuts-30.jpeg";

// Full-bleed cinematic Yolanda band displayed above the site footer on Home.
export const YOLANDA_FOOTER_BAND =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_yolanda-cuts/artifacts/xqiofdle_IMG_7593.jpeg";

// Curated 3-photo preview shown on the homepage — a highly composed teaser
// that funnels visitors to /photos. NOT the full gallery.
export const HOME_PHOTO_PREVIEW = [
  { src: "/gallery/shecuts-01.jpeg", caption: "Sharp Fade — Textured Top",   tag: "Fades · Beards" },
  { src: "/gallery/shecuts-30.jpeg", caption: "Custom Color · Locs",          tag: "Women · Designs" },
  { src: "/gallery/shecuts-08.jpeg", caption: "Precision Craft",              tag: "Fades" },
];
